import { render, staticRenderFns } from "./IntercomLink.vue?vue&type=template&id=48696c46"
import script from "./IntercomLink.vue?vue&type=script&lang=js"
export * from "./IntercomLink.vue?vue&type=script&lang=js"
import style0 from "./IntercomLink.vue?vue&type=style&index=0&id=48696c46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports